import { jsx as C, jsxs as oe, Fragment as Ae } from "react/jsx-runtime";
import ot, { createContext as Tt, useContext as me, useReducer as vr, useMemo as Jt, useRef as Cr, useDebugValue as Ot, createElement as Tr, useEffect as $e, Component as Ar, useState as Nt, useCallback as Rr } from "react";
import { initReactI18next as _r, useTranslation as Se, Trans as It, I18nextProvider as wr } from "react-i18next";
import { createInstance as br } from "i18next";
import Pr from "i18next-browser-languagedetector";
import Re from "syf-component-library/const/mediaQueries";
import { spacing as fe, fontWeights as Ie, fontSizes as ye, colors as er, lineHeights as Dt } from "syf-component-library/defaultTheme";
import At from "syf-component-library/ui/typography/Body";
import { SlideInModalPortal as xr, ModalHeader as Or } from "syf-component-library/ui/patterns/SlideInModalPortal";
import { useAccountSummaryV2Query as Nr } from "@syf-api-library/account-summary";
import { usePersonalizedCardArtQuery as Ir } from "@syf-api-library/personalized-card-art";
import { useProfileScopeQuery as Dr, useProfileQuery as Mr } from "@syf-api-library/profile";
import { useQueryClient as kr, useQuery as Lr } from "@tanstack/react-query";
import { ModalFooter as $r } from "syf-component-library/ui/patterns/SlideInModal";
import { Stack as et } from "syf-component-library/ui/spacing";
import { HTTPError as Ur } from "syf-js-utilities";
import { SyfLoader as Fr } from "syf-component-library/ui";
const De = Tt({
  selectedAccountId: "",
  triggerAnalyticsEvent: () => {
  },
  authenticationRedirect: () => null,
  envProp: "development"
}), at = () => me(De), zr = { BuildVersion: "1.2.2" }, K = { CUSTOM_CARD: "custom card" }, Y = { CUSTOM_CARD: "custom card" }, ue = {
  EXIT: "exit",
  GUIDELINE: "guideline",
  INSTRUCTIONS: "instructions",
  PLACE_ORDER: "place order",
  RESET: "reset",
  STATUSES: "statuses"
}, X = {
  APPROVED: "approved",
  COMPLETE: "complete",
  CONFIRMATION: "confirmation",
  CARD_SENT: "card sent",
  EDITOR: "editor",
  ERROR: "error",
  PENDING: "pending",
  PREVIEW: "preview",
  REJECTED: "rejected",
  START: "start",
  TECHNICAL_ERROR: "technical error",
  VIEW: "view"
}, Ne = {
  APPROVED: "card sent for approval",
  CARD_SENT: "card is on it's way",
  CHANGES_UNDONE: "Any changes will be undone",
  IMAGE_FILL_CONTAINER: "Image must fill container",
  LOSE_ALL_PROGRESS: "You'll lose all progress",
  REJECTED: "card has been rejected",
  SENT_FOR_APPROVAL: "Your custom artwork is being sent for approval!"
}, ke = {
  API_FAILURE: "api failure",
  EXIT_CONFIRMATION: "Exit confirmation",
  IMAGE_RESET_CONFIRMATION: "Image reset confirmation",
  VALIDATION_FAILURE: "validation failure"
}, Le = {
  EXIT_CONFIRMATION: "Are you sure you want to exit?",
  FILE_FORMAT_NOT_SUPPORTED: "image too large",
  IMAGE_RESET_CONFIRMATION: "Are you sure you want to reset your image?",
  IMAGE_TOO_LARGE: "image too large",
  IMAGE_TOO_SMALL: "image too small",
  TECHNICAL_ERROR: "experiencing technical difficulties"
}, Te = "button", We = "close", Yr = "cancel", jr = "get started", Gr = "X", Vr = "upload new image", Mt = {
  cardPrintingInProgress: {
    pageKind: K.CUSTOM_CARD,
    pageFunction: Y.CUSTOM_CARD,
    pageSubFunction: ue.STATUSES,
    pageName: X.APPROVED,
    message: Ne.APPROVED
  },
  cardSent: {
    pageKind: K.CUSTOM_CARD,
    pageFunction: Y.CUSTOM_CARD,
    pageSubFunction: ue.STATUSES,
    pageName: X.CARD_SENT,
    message: Ne.CARD_SENT
  },
  getStarted: {
    PageFunction: Y.CUSTOM_CARD,
    PageKind: K.CUSTOM_CARD,
    pageName: X.START
  },
  pending: {
    pageKind: K.CUSTOM_CARD,
    pageFunction: Y.CUSTOM_CARD,
    pageSubFunction: ue.STATUSES,
    pageName: X.PENDING
  },
  rejected: {
    pageKind: K.CUSTOM_CARD,
    pageFunction: Y.CUSTOM_CARD,
    pageSubFunction: ue.STATUSES,
    pageName: X.REJECTED,
    message: Ne.REJECTED
  }
}, Br = {
  getStarted: ["manageCardArt"],
  manageCardArt: ["error"],
  pending: ["error"],
  cardPrintingInProgress: ["error"],
  cardSent: ["error"],
  rejected: ["getStarted", "error"],
  error: []
}, tr = {
  isModalOpen: !0
}, Hr = (e, r) => r.type === "TRANSITION" ? { ...e, activeScreen: r.payload } : r.type === "RESET" ? { ...e, activeScreen: void 0 } : e, rr = Tt({
  ...tr,
  handleModalClose: () => {
  },
  transition: () => {
  },
  reset: () => {
  }
}), Wr = ({ children: e, handleModalClose: r, isModalOpen: t }) => {
  const [n, i] = vr(Hr, tr), { triggerAnalyticsEvent: s } = at(), c = () => {
    i({ type: "RESET" });
  }, u = Jt(() => ({
    ...n,
    isModalOpen: t,
    handleModalClose: () => {
      c(), r();
    },
    transition: (f) => {
      if (!n.activeScreen || Br[n.activeScreen].includes(f)) {
        i({ type: "TRANSITION", payload: f }), Mt[f] !== void 0 && s(Mt[f]);
        return;
      }
      console.error(`
          Invalid transition from ${n.activeScreen} to ${f}`);
    },
    reset: c
  }), [r, t, n, s]);
  return /* @__PURE__ */ C(rr.Provider, { value: u, children: e });
}, _e = () => me(rr), Rt = Tt(void 0), Kr = Rt.Provider, it = () => {
  const e = me(Rt);
  if (!e)
    throw new Error("No config");
  return e;
}, Xr = {
  title: {
    drawerTitle: "{{portfolioName}} Custom Card Art"
  },
  button: {
    closeButtonText: "Close",
    cancelButtonText: "Cancel",
    uploadNewImage: "Upload New Image",
    getStarted: "Get Started"
  },
  labels: {
    tryAgainText: "Please try again later.",
    customCardArtLoaderText: "One moment please"
  },
  headings: {
    technicalErrorTitle: "We are currently experiencing technical difficulties"
  },
  screen: {
    getStarted: {
      title: "Now you can customize your {{portfolioName}} credit card!",
      offeringDescription: "{{portfolioName}} is offering a new way to carry your best friend everywhere you go: a customized {{portfolioName}} credit card featuring a photo of your favorite pet!",
      processDescription: "Simply upload a photo of your pet, adjust it to fit the way you want, and submit your order for approval. Once approved, your new custom {{portfolioName}} credit card should arrive within 8 to 12 business days at no charge to you.",
      extraNoteDescription: "Note: You can only customize your card once, so make sure you love it before you submit your order.",
      customizeNowDescription: "Customize Now!"
    },
    cardPrintingInProgress: {
      title: "Your {{portfolioName}} credit card artwork has been approved!",
      primaryDescriptionText: "We’ve approved your artwork submission and are printing your new {{portfolioName}} credit card now. You should receive your new card in 8 to 12 business days."
    },
    pending: {
      title: "Your {{portfolioName}} credit card custom artwork is being sent for approval!",
      primaryDescriptionText: "You are all set. Once your card art is approved, we will get it in the mail for you. If approved, you should receive your new card in 8 to 12 business days."
    },
    rejected: {
      title: "Your {{portfolioName}} credit card custom artwork has been rejected.",
      primaryDescriptionText: "During review of your artwork submission for your {{portfolioName}} credit card, our team found inappropriate messages, images, or other content that is not allowed. If you attempt to resubmit new artwork, please refrain from uploading inappropriate, copy-written, or trademarked content."
    },
    cardSent: {
      title: "Your customized {{portfolioName}} credit card is on its way!",
      primaryDescriptionText: "We’ve printed and shipped your new {{portfolioName}} credit card. You should receive your new card within 8 to 12 business days."
    },
    common: {
      secondaryDescriptionText: "Until then, you can still use your current {{portfolioName}} credit card."
    }
  },
  subHeadings: {},
  helperNotes: {},
  errorText: {}
}, qr = {
  title: {
    drawerTitle: "Personalización de Diseño de Arte de Tarjetas {{portfolioName}}"
  },
  button: {
    closeButtonText: "Cerrar",
    cancelButtonText: "Cancelar",
    uploadNewImage: "Cargar nueva imagen",
    getStarted: "Para comenzar"
  },
  labels: {
    tryAgainText: "Intente nuevamente más tarde.",
    customCardArtLoaderText: "Uno momento por favor"
  },
  headings: {
    technicalErrorTitle: "Actualmente, estamos experimentando dificultades técnicas"
  },
  screen: {
    getStarted: {
      title: "¡Ahora puede personalizar su tarjeta de crédito {{portfolioName}}!",
      offeringDescription: "{{portfolioName}} le ofrece una nueva forma de llevar a su mejor amigo a donde quiera que vaya: ¡una tarjeta de crédito {{portfolioName}} personalizada con una foto de su mascota favorita!",
      processDescription: "Simplemente, cargue una foto de su mascota, ajústela de la manera que desee y envíe su orden para su aprobación. Una vez aprobada, su nueva tarjeta de crédito {{portfolioName}} personalizada debería llegar dentro de 8 a 12 días hábiles sin costo para usted.",
      extraNoteDescription: "Nota: Solo puede personalizar su tarjeta una vez, así que asegúrese de que le guste antes de enviar su orden.",
      customizeNowDescription: "Personalizar Ahora!"
    },
    cardPrintingInProgress: {
      title: "¡El diseño de arte de su tarjeta de crédito {{portfolioName}} ha sido aprobado!",
      primaryDescriptionText: "Hemos aprobado su diseño de arte y ahora estamos imprimiendo su nueva tarjeta de crédito {{portfolioName}}. Debería recibir su nueva tarjeta dentro de 8 a 12 días hábiles."
    },
    pending: {
      title: "¡El diseño de arte personalizado de su tarjeta de crédito {{portfolioName}} se está enviando para su aprobación!",
      primaryDescriptionText: "Ya está todo listo. Una vez que se apruebe el diseño de arte de su tarjeta, se la enviaremos por correo postal. Si se aprueba, debería recibir su nueva tarjeta dentro de 8 a 12 días hábiles."
    },
    rejected: {
      title: "El diseño de arte personalizado de su tarjeta de crédito {{portfolioName}} ha sido rechazado.",
      primaryDescriptionText: "Durante la revisión del diseño de arte enviado para su tarjeta de crédito {{portfolioName}}, nuestro equipo encontró mensajes, imágenes u otro contenido inapropiado que no está permitido. Si intenta volver a enviar un nuevo diseño de arte, absténgase de cargar contenido inapropiado, con derechos de autor o marca registrada."
    },
    cardSent: {
      title: "¡Su tarjeta de crédito {{portfolioName}} personalizada está en camino!",
      primaryDescriptionText: "Hemos impreso y enviado su nueva tarjeta de crédito {{portfolioName}}. Debería recibir su nueva tarjeta dentro de 8 a 12 días hábiles."
    },
    common: {
      secondaryDescriptionText: "Hasta entonces, puede seguir usando su tarjeta de crédito {{portfolioName}} actual."
    }
  },
  subHeadings: {},
  helperNotes: {},
  errorText: {}
}, Ue = "CustomCardArt", Qr = {
  en: {
    [Ue]: Xr
  },
  es: {
    [Ue]: qr
  }
}, pe = br({
  debug: !1,
  fallbackLng: "en",
  interpolation: { escapeValue: !1 },
  resources: Qr,
  defaultNS: Ue
});
pe.use(new Pr(null, { lookupLocalStorage: "language" })).use(_r).init();
const Zr = "assets/card-actions-mfe/technical-error.svg", Jr = "assets/card-actions-mfe/error-blocked.svg", en = "assets/card-actions-mfe/thumbs-up.svg", nr = "assets/card-actions-mfe/hands-greeting-high-five.svg", tn = "assets/card-actions-mfe/Pet-CardArt.svg", rn = "assets/card-actions-mfe/CareCredit-MasterCard-template.svg", nn = "assets/card-actions-mfe/CareCredit-PrivateLabel-template.svg";
function on(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var mt = { exports: {} }, U = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kt;
function an() {
  if (kt)
    return U;
  kt = 1;
  var e = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.consumer"), c = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), m = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), R = Symbol.for("react.view_transition"), x = Symbol.for("react.client.reference");
  function g(o) {
    if (typeof o == "object" && o !== null) {
      var v = o.$$typeof;
      switch (v) {
        case e:
          switch (o = o.type, o) {
            case t:
            case i:
            case n:
            case f:
            case m:
            case R:
              return o;
            default:
              switch (o = o && o.$$typeof, o) {
                case c:
                case u:
                case T:
                case E:
                  return o;
                case s:
                  return o;
                default:
                  return v;
              }
          }
        case r:
          return v;
      }
    }
  }
  return U.ContextConsumer = s, U.ContextProvider = c, U.Element = e, U.ForwardRef = u, U.Fragment = t, U.Lazy = T, U.Memo = E, U.Portal = r, U.Profiler = i, U.StrictMode = n, U.Suspense = f, U.SuspenseList = m, U.isContextConsumer = function(o) {
    return g(o) === s;
  }, U.isContextProvider = function(o) {
    return g(o) === c;
  }, U.isElement = function(o) {
    return typeof o == "object" && o !== null && o.$$typeof === e;
  }, U.isForwardRef = function(o) {
    return g(o) === u;
  }, U.isFragment = function(o) {
    return g(o) === t;
  }, U.isLazy = function(o) {
    return g(o) === T;
  }, U.isMemo = function(o) {
    return g(o) === E;
  }, U.isPortal = function(o) {
    return g(o) === r;
  }, U.isProfiler = function(o) {
    return g(o) === i;
  }, U.isStrictMode = function(o) {
    return g(o) === n;
  }, U.isSuspense = function(o) {
    return g(o) === f;
  }, U.isSuspenseList = function(o) {
    return g(o) === m;
  }, U.isValidElementType = function(o) {
    return typeof o == "string" || typeof o == "function" || o === t || o === i || o === n || o === f || o === m || typeof o == "object" && o !== null && (o.$$typeof === T || o.$$typeof === E || o.$$typeof === c || o.$$typeof === s || o.$$typeof === u || o.$$typeof === x || o.getModuleId !== void 0);
  }, U.typeOf = g, U;
}
var F = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lt;
function sn() {
  return Lt || (Lt = 1, process.env.NODE_ENV !== "production" && function() {
    function e(o) {
      if (typeof o == "object" && o !== null) {
        var v = o.$$typeof;
        switch (v) {
          case r:
            switch (o = o.type, o) {
              case n:
              case s:
              case i:
              case m:
              case E:
              case x:
                return o;
              default:
                switch (o = o && o.$$typeof, o) {
                  case u:
                  case f:
                  case R:
                  case T:
                    return o;
                  case c:
                    return o;
                  default:
                    return v;
                }
            }
          case t:
            return v;
        }
      }
    }
    var r = Symbol.for("react.transitional.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), c = Symbol.for("react.consumer"), u = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), x = Symbol.for("react.view_transition"), g = Symbol.for("react.client.reference");
    F.ContextConsumer = c, F.ContextProvider = u, F.Element = r, F.ForwardRef = f, F.Fragment = n, F.Lazy = R, F.Memo = T, F.Portal = t, F.Profiler = s, F.StrictMode = i, F.Suspense = m, F.SuspenseList = E, F.isContextConsumer = function(o) {
      return e(o) === c;
    }, F.isContextProvider = function(o) {
      return e(o) === u;
    }, F.isElement = function(o) {
      return typeof o == "object" && o !== null && o.$$typeof === r;
    }, F.isForwardRef = function(o) {
      return e(o) === f;
    }, F.isFragment = function(o) {
      return e(o) === n;
    }, F.isLazy = function(o) {
      return e(o) === R;
    }, F.isMemo = function(o) {
      return e(o) === T;
    }, F.isPortal = function(o) {
      return e(o) === t;
    }, F.isProfiler = function(o) {
      return e(o) === s;
    }, F.isStrictMode = function(o) {
      return e(o) === i;
    }, F.isSuspense = function(o) {
      return e(o) === m;
    }, F.isSuspenseList = function(o) {
      return e(o) === E;
    }, F.isValidElementType = function(o) {
      return typeof o == "string" || typeof o == "function" || o === n || o === s || o === i || o === m || o === E || typeof o == "object" && o !== null && (o.$$typeof === R || o.$$typeof === T || o.$$typeof === u || o.$$typeof === c || o.$$typeof === f || o.$$typeof === g || o.getModuleId !== void 0);
    }, F.typeOf = e;
  }()), F;
}
process.env.NODE_ENV === "production" ? mt.exports = an() : mt.exports = sn();
var _t = mt.exports;
function cn(e) {
  function r(S, h, y, P, a) {
    for (var D = 0, p = 0, z = 0, M = 0, I, l, j = 0, H = 0, O, ee = O = I = 0, k = 0, Q = 0, Ge = 0, Z = 0, Ke = y.length, Ve = Ke - 1, de, w = "", G = "", lt = "", dt = "", Ee; k < Ke; ) {
      if (l = y.charCodeAt(k), k === Ve && p + M + z + D !== 0 && (p !== 0 && (l = p === 47 ? 10 : 47), M = z = D = 0, Ke++, Ve++), p + M + z + D === 0) {
        if (k === Ve && (0 < Q && (w = w.replace(R, "")), 0 < w.trim().length)) {
          switch (l) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              w += y.charAt(k);
          }
          l = 59;
        }
        switch (l) {
          case 123:
            for (w = w.trim(), I = w.charCodeAt(0), O = 1, Z = ++k; k < Ke; ) {
              switch (l = y.charCodeAt(k)) {
                case 123:
                  O++;
                  break;
                case 125:
                  O--;
                  break;
                case 47:
                  switch (l = y.charCodeAt(k + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (ee = k + 1; ee < Ve; ++ee)
                          switch (y.charCodeAt(ee)) {
                            case 47:
                              if (l === 42 && y.charCodeAt(ee - 1) === 42 && k + 2 !== ee) {
                                k = ee + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (l === 47) {
                                k = ee + 1;
                                break e;
                              }
                          }
                        k = ee;
                      }
                  }
                  break;
                case 91:
                  l++;
                case 40:
                  l++;
                case 34:
                case 39:
                  for (; k++ < Ve && y.charCodeAt(k) !== l; )
                    ;
              }
              if (O === 0)
                break;
              k++;
            }
            switch (O = y.substring(Z, k), I === 0 && (I = (w = w.replace(T, "").trim()).charCodeAt(0)), I) {
              case 64:
                switch (0 < Q && (w = w.replace(R, "")), l = w.charCodeAt(1), l) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    Q = h;
                    break;
                  default:
                    Q = we;
                }
                if (O = r(h, Q, O, l, a + 1), Z = O.length, 0 < re && (Q = t(we, w, Ge), Ee = u(3, O, Q, h, ne, te, Z, l, a, P), w = Q.join(""), Ee !== void 0 && (Z = (O = Ee.trim()).length) === 0 && (l = 0, O = "")), 0 < Z)
                  switch (l) {
                    case 115:
                      w = w.replace(B, c);
                    case 100:
                    case 109:
                    case 45:
                      O = w + "{" + O + "}";
                      break;
                    case 107:
                      w = w.replace(_, "$1 $2"), O = w + "{" + O + "}", O = J === 1 || J === 2 && s("@" + O, 3) ? "@-webkit-" + O + "@" + O : "@" + O;
                      break;
                    default:
                      O = w + O, P === 112 && (O = (G += O, ""));
                  }
                else
                  O = "";
                break;
              default:
                O = r(h, t(h, w, Ge), O, P, a + 1);
            }
            lt += O, O = Ge = Q = ee = I = 0, w = "", l = y.charCodeAt(++k);
            break;
          case 125:
          case 59:
            if (w = (0 < Q ? w.replace(R, "") : w).trim(), 1 < (Z = w.length))
              switch (ee === 0 && (I = w.charCodeAt(0), I === 45 || 96 < I && 123 > I) && (Z = (w = w.replace(" ", ":")).length), 0 < re && (Ee = u(1, w, h, S, ne, te, G.length, P, a, P)) !== void 0 && (Z = (w = Ee.trim()).length) === 0 && (w = "\0\0"), I = w.charCodeAt(0), l = w.charCodeAt(1), I) {
                case 0:
                  break;
                case 64:
                  if (l === 105 || l === 99) {
                    dt += w + y.charAt(k);
                    break;
                  }
                default:
                  w.charCodeAt(Z - 1) !== 58 && (G += i(w, I, l, w.charCodeAt(2)));
              }
            Ge = Q = ee = I = 0, w = "", l = y.charCodeAt(++k);
        }
      }
      switch (l) {
        case 13:
        case 10:
          p === 47 ? p = 0 : 1 + I === 0 && P !== 107 && 0 < w.length && (Q = 1, w += "\0"), 0 < re * he && u(0, w, h, S, ne, te, G.length, P, a, P), te = 1, ne++;
          break;
        case 59:
        case 125:
          if (p + M + z + D === 0) {
            te++;
            break;
          }
        default:
          switch (te++, de = y.charAt(k), l) {
            case 9:
            case 32:
              if (M + D + p === 0)
                switch (j) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    de = "";
                    break;
                  default:
                    l !== 32 && (de = " ");
                }
              break;
            case 0:
              de = "\\0";
              break;
            case 12:
              de = "\\f";
              break;
            case 11:
              de = "\\v";
              break;
            case 38:
              M + p + D === 0 && (Q = Ge = 1, de = "\f" + de);
              break;
            case 108:
              if (M + p + D + ce === 0 && 0 < ee)
                switch (k - ee) {
                  case 2:
                    j === 112 && y.charCodeAt(k - 3) === 58 && (ce = j);
                  case 8:
                    H === 111 && (ce = H);
                }
              break;
            case 58:
              M + p + D === 0 && (ee = k);
              break;
            case 44:
              p + z + M + D === 0 && (Q = 1, de += "\r");
              break;
            case 34:
            case 39:
              p === 0 && (M = M === l ? 0 : M === 0 ? l : M);
              break;
            case 91:
              M + p + z === 0 && D++;
              break;
            case 93:
              M + p + z === 0 && D--;
              break;
            case 41:
              M + p + D === 0 && z--;
              break;
            case 40:
              if (M + p + D === 0) {
                if (I === 0)
                  switch (2 * j + 3 * H) {
                    case 533:
                      break;
                    default:
                      I = 1;
                  }
                z++;
              }
              break;
            case 64:
              p + z + M + D + ee + O === 0 && (O = 1);
              break;
            case 42:
            case 47:
              if (!(0 < M + D + z))
                switch (p) {
                  case 0:
                    switch (2 * l + 3 * y.charCodeAt(k + 1)) {
                      case 235:
                        p = 47;
                        break;
                      case 220:
                        Z = k, p = 42;
                    }
                    break;
                  case 42:
                    l === 47 && j === 42 && Z + 2 !== k && (y.charCodeAt(Z + 2) === 33 && (G += y.substring(Z, k + 1)), de = "", p = 0);
                }
          }
          p === 0 && (w += de);
      }
      H = j, j = l, k++;
    }
    if (Z = G.length, 0 < Z) {
      if (Q = h, 0 < re && (Ee = u(2, G, Q, S, ne, te, Z, P, a, P), Ee !== void 0 && (G = Ee).length === 0))
        return dt + G + lt;
      if (G = Q.join(",") + "{" + G + "}", J * ce !== 0) {
        switch (J !== 2 || s(G, 2) || (ce = 0), ce) {
          case 111:
            G = G.replace(A, ":-moz-$1") + G;
            break;
          case 112:
            G = G.replace(b, "::-webkit-input-$1") + G.replace(b, "::-moz-$1") + G.replace(b, ":-ms-input-$1") + G;
        }
        ce = 0;
      }
    }
    return dt + G + lt;
  }
  function t(S, h, y) {
    var P = h.trim().split(v);
    h = P;
    var a = P.length, D = S.length;
    switch (D) {
      case 0:
      case 1:
        var p = 0;
        for (S = D === 0 ? "" : S[0] + " "; p < a; ++p)
          h[p] = n(S, h[p], y).trim();
        break;
      default:
        var z = p = 0;
        for (h = []; p < a; ++p)
          for (var M = 0; M < D; ++M)
            h[z++] = n(S[M] + " ", P[p], y).trim();
    }
    return h;
  }
  function n(S, h, y) {
    var P = h.charCodeAt(0);
    switch (33 > P && (P = (h = h.trim()).charCodeAt(0)), P) {
      case 38:
        return h.replace(N, "$1" + S.trim());
      case 58:
        return S.trim() + h.replace(N, "$1" + S.trim());
      default:
        if (0 < 1 * y && 0 < h.indexOf("\f"))
          return h.replace(N, (S.charCodeAt(0) === 58 ? "" : "$1") + S.trim());
    }
    return S + h;
  }
  function i(S, h, y, P) {
    var a = S + ";", D = 2 * h + 3 * y + 4 * P;
    if (D === 944) {
      S = a.indexOf(":", 9) + 1;
      var p = a.substring(S, a.length - 1).trim();
      return p = a.substring(0, S).trim() + p + ";", J === 1 || J === 2 && s(p, 1) ? "-webkit-" + p + p : p;
    }
    if (J === 0 || J === 2 && !s(a, 1))
      return a;
    switch (D) {
      case 1015:
        return a.charCodeAt(10) === 97 ? "-webkit-" + a + a : a;
      case 951:
        return a.charCodeAt(3) === 116 ? "-webkit-" + a + a : a;
      case 963:
        return a.charCodeAt(5) === 110 ? "-webkit-" + a + a : a;
      case 1009:
        if (a.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (a.charCodeAt(8) === 45)
          return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11))
          return a.replace(ae, "$1-webkit-$2") + a;
        break;
      case 932:
        if (a.charCodeAt(4) === 45)
          switch (a.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
            case 115:
              return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
            case 98:
              return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
          }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (a.charCodeAt(8) !== 99)
          break;
        return p = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + p + "-webkit-" + a + "-ms-flex-pack" + p + a;
      case 1005:
        return g.test(a) ? a.replace(x, ":-webkit-") + a.replace(x, ":-moz-") + a : a;
      case 1e3:
        switch (p = a.substring(13).trim(), h = p.indexOf("-") + 1, p.charCodeAt(0) + p.charCodeAt(h)) {
          case 226:
            p = a.replace(d, "tb");
            break;
          case 232:
            p = a.replace(d, "tb-rl");
            break;
          case 220:
            p = a.replace(d, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + p + a;
      case 1017:
        if (a.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (h = (a = S).length - 10, p = (a.charCodeAt(h) === 33 ? a.substring(0, h) : a).substring(S.indexOf(":", 7) + 1).trim(), D = p.charCodeAt(0) + (p.charCodeAt(7) | 0)) {
          case 203:
            if (111 > p.charCodeAt(8))
              break;
          case 115:
            a = a.replace(p, "-webkit-" + p) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(p, "-webkit-" + (102 < D ? "inline-" : "") + "box") + ";" + a.replace(p, "-webkit-" + p) + ";" + a.replace(p, "-ms-" + p + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (a.charCodeAt(5) === 45)
          switch (a.charCodeAt(6)) {
            case 105:
              return p = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + p + "-ms-flex-" + p + a;
            case 115:
              return "-webkit-" + a + "-ms-flex-item-" + a.replace(q, "") + a;
            default:
              return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(q, "") + a;
          }
        break;
      case 973:
      case 989:
        if (a.charCodeAt(3) !== 45 || a.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (le.test(S) === !0)
          return (p = S.substring(S.indexOf(":") + 1)).charCodeAt(0) === 115 ? i(S.replace("stretch", "fill-available"), h, y, P).replace(":fill-available", ":stretch") : a.replace(p, "-webkit-" + p) + a.replace(p, "-moz-" + p.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (a.charCodeAt(5) === 102 ? "-ms-" + a : "") + a, y + P === 211 && a.charCodeAt(13) === 105 && 0 < a.indexOf("transform", 10))
          return a.substring(0, a.indexOf(";", 27) + 1).replace(o, "$1-webkit-$2") + a;
    }
    return a;
  }
  function s(S, h) {
    var y = S.indexOf(h === 1 ? ":" : "{"), P = S.substring(0, h !== 3 ? y : 10);
    return y = S.substring(y + 1, S.length - 1), be(h !== 2 ? P : P.replace(W, "$1"), y, h);
  }
  function c(S, h) {
    var y = i(h, h.charCodeAt(0), h.charCodeAt(1), h.charCodeAt(2));
    return y !== h + ";" ? y.replace(se, " or ($1)").substring(4) : "(" + h + ")";
  }
  function u(S, h, y, P, a, D, p, z, M, I) {
    for (var l = 0, j = h, H; l < re; ++l)
      switch (H = ie[l].call(E, S, j, y, P, a, D, p, z, M, I)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          j = H;
      }
    if (j !== h)
      return j;
  }
  function f(S) {
    switch (S) {
      case void 0:
      case null:
        re = ie.length = 0;
        break;
      default:
        if (typeof S == "function")
          ie[re++] = S;
        else if (typeof S == "object")
          for (var h = 0, y = S.length; h < y; ++h)
            f(S[h]);
        else
          he = !!S | 0;
    }
    return f;
  }
  function m(S) {
    return S = S.prefix, S !== void 0 && (be = null, S ? typeof S != "function" ? J = 1 : (J = 2, be = S) : J = 0), m;
  }
  function E(S, h) {
    var y = S;
    if (33 > y.charCodeAt(0) && (y = y.trim()), Pe = y, y = [Pe], 0 < re) {
      var P = u(-1, h, y, y, ne, te, 0, 0, 0, 0);
      P !== void 0 && typeof P == "string" && (h = P);
    }
    var a = r(we, y, h, 0, 0);
    return 0 < re && (P = u(-2, a, y, y, ne, te, a.length, 0, 0, 0), P !== void 0 && (a = P)), Pe = "", ce = 0, te = ne = 1, a;
  }
  var T = /^\0+/g, R = /[\0\r\f]/g, x = /: */g, g = /zoo|gra/, o = /([,: ])(transform)/g, v = /,\r+?/g, N = /([\t\r\n ])*\f?&/g, _ = /@(k\w+)\s*(\S*)\s*/, b = /::(place)/g, A = /:(read-only)/g, d = /[svh]\w+-[tblr]{2}/, B = /\(\s*(.*)\s*\)/g, se = /([\s\S]*?);/g, q = /-self|flex-/g, W = /[^]*?(:[rp][el]a[\w-]+)[^]*/, le = /stretch|:\s*\w+\-(?:conte|avail)/, ae = /([^-])(image-set\()/, te = 1, ne = 1, ce = 0, J = 1, we = [], ie = [], re = 0, be = null, he = 0, Pe = "";
  return E.use = f, E.set = m, e !== void 0 && m(e), E;
}
var ln = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function dn(e) {
  var r = {};
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var un = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, $t = dn(
  function(e) {
    return un.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), ht = { exports: {} }, L = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ut;
function pn() {
  if (Ut)
    return L;
  Ut = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, E = e ? Symbol.for("react.forward_ref") : 60112, T = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, o = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function b(d) {
    if (typeof d == "object" && d !== null) {
      var B = d.$$typeof;
      switch (B) {
        case r:
          switch (d = d.type, d) {
            case f:
            case m:
            case n:
            case s:
            case i:
            case T:
              return d;
            default:
              switch (d = d && d.$$typeof, d) {
                case u:
                case E:
                case g:
                case x:
                case c:
                  return d;
                default:
                  return B;
              }
          }
        case t:
          return B;
      }
    }
  }
  function A(d) {
    return b(d) === m;
  }
  return L.AsyncMode = f, L.ConcurrentMode = m, L.ContextConsumer = u, L.ContextProvider = c, L.Element = r, L.ForwardRef = E, L.Fragment = n, L.Lazy = g, L.Memo = x, L.Portal = t, L.Profiler = s, L.StrictMode = i, L.Suspense = T, L.isAsyncMode = function(d) {
    return A(d) || b(d) === f;
  }, L.isConcurrentMode = A, L.isContextConsumer = function(d) {
    return b(d) === u;
  }, L.isContextProvider = function(d) {
    return b(d) === c;
  }, L.isElement = function(d) {
    return typeof d == "object" && d !== null && d.$$typeof === r;
  }, L.isForwardRef = function(d) {
    return b(d) === E;
  }, L.isFragment = function(d) {
    return b(d) === n;
  }, L.isLazy = function(d) {
    return b(d) === g;
  }, L.isMemo = function(d) {
    return b(d) === x;
  }, L.isPortal = function(d) {
    return b(d) === t;
  }, L.isProfiler = function(d) {
    return b(d) === s;
  }, L.isStrictMode = function(d) {
    return b(d) === i;
  }, L.isSuspense = function(d) {
    return b(d) === T;
  }, L.isValidElementType = function(d) {
    return typeof d == "string" || typeof d == "function" || d === n || d === m || d === s || d === i || d === T || d === R || typeof d == "object" && d !== null && (d.$$typeof === g || d.$$typeof === x || d.$$typeof === c || d.$$typeof === u || d.$$typeof === E || d.$$typeof === v || d.$$typeof === N || d.$$typeof === _ || d.$$typeof === o);
  }, L.typeOf = b, L;
}
var $ = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ft;
function fn() {
  return Ft || (Ft = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, s = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, E = e ? Symbol.for("react.forward_ref") : 60112, T = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, x = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, o = e ? Symbol.for("react.block") : 60121, v = e ? Symbol.for("react.fundamental") : 60117, N = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function b(l) {
      return typeof l == "string" || typeof l == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      l === n || l === m || l === s || l === i || l === T || l === R || typeof l == "object" && l !== null && (l.$$typeof === g || l.$$typeof === x || l.$$typeof === c || l.$$typeof === u || l.$$typeof === E || l.$$typeof === v || l.$$typeof === N || l.$$typeof === _ || l.$$typeof === o);
    }
    function A(l) {
      if (typeof l == "object" && l !== null) {
        var j = l.$$typeof;
        switch (j) {
          case r:
            var H = l.type;
            switch (H) {
              case f:
              case m:
              case n:
              case s:
              case i:
              case T:
                return H;
              default:
                var O = H && H.$$typeof;
                switch (O) {
                  case u:
                  case E:
                  case g:
                  case x:
                  case c:
                    return O;
                  default:
                    return j;
                }
            }
          case t:
            return j;
        }
      }
    }
    var d = f, B = m, se = u, q = c, W = r, le = E, ae = n, te = g, ne = x, ce = t, J = s, we = i, ie = T, re = !1;
    function be(l) {
      return re || (re = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), he(l) || A(l) === f;
    }
    function he(l) {
      return A(l) === m;
    }
    function Pe(l) {
      return A(l) === u;
    }
    function S(l) {
      return A(l) === c;
    }
    function h(l) {
      return typeof l == "object" && l !== null && l.$$typeof === r;
    }
    function y(l) {
      return A(l) === E;
    }
    function P(l) {
      return A(l) === n;
    }
    function a(l) {
      return A(l) === g;
    }
    function D(l) {
      return A(l) === x;
    }
    function p(l) {
      return A(l) === t;
    }
    function z(l) {
      return A(l) === s;
    }
    function M(l) {
      return A(l) === i;
    }
    function I(l) {
      return A(l) === T;
    }
    $.AsyncMode = d, $.ConcurrentMode = B, $.ContextConsumer = se, $.ContextProvider = q, $.Element = W, $.ForwardRef = le, $.Fragment = ae, $.Lazy = te, $.Memo = ne, $.Portal = ce, $.Profiler = J, $.StrictMode = we, $.Suspense = ie, $.isAsyncMode = be, $.isConcurrentMode = he, $.isContextConsumer = Pe, $.isContextProvider = S, $.isElement = h, $.isForwardRef = y, $.isFragment = P, $.isLazy = a, $.isMemo = D, $.isPortal = p, $.isProfiler = z, $.isStrictMode = M, $.isSuspense = I, $.isValidElementType = b, $.typeOf = A;
  }()), $;
}
process.env.NODE_ENV === "production" ? ht.exports = pn() : ht.exports = fn();
var mn = ht.exports, wt = mn, hn = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, gn = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, yn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, or = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, bt = {};
bt[wt.ForwardRef] = yn;
bt[wt.Memo] = or;
function zt(e) {
  return wt.isMemo(e) ? or : bt[e.$$typeof] || hn;
}
var Sn = Object.defineProperty, En = Object.getOwnPropertyNames, Yt = Object.getOwnPropertySymbols, vn = Object.getOwnPropertyDescriptor, Cn = Object.getPrototypeOf, jt = Object.prototype;
function ar(e, r, t) {
  if (typeof r != "string") {
    if (jt) {
      var n = Cn(r);
      n && n !== jt && ar(e, n, t);
    }
    var i = En(r);
    Yt && (i = i.concat(Yt(r)));
    for (var s = zt(e), c = zt(r), u = 0; u < i.length; ++u) {
      var f = i[u];
      if (!gn[f] && !(t && t[f]) && !(c && c[f]) && !(s && s[f])) {
        var m = vn(r, f);
        try {
          Sn(e, f, m);
        } catch {
        }
      }
    }
  }
  return e;
}
var Tn = ar;
const An = /* @__PURE__ */ on(Tn);
function ge() {
  return (ge = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }).apply(this, arguments);
}
var Gt = function(e, r) {
  for (var t = [e[0]], n = 0, i = r.length; n < i; n += 1)
    t.push(r[n], e[n + 1]);
  return t;
}, gt = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !_t.typeOf(e);
}, rt = Object.freeze([]), Ce = Object.freeze({});
function He(e) {
  return typeof e == "function";
}
function yt(e) {
  return process.env.NODE_ENV !== "production" && typeof e == "string" && e || e.displayName || e.name || "Component";
}
function Pt(e) {
  return e && typeof e.styledComponentId == "string";
}
var Fe = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", xt = typeof window < "u" && "HTMLElement" in window, Rn = !!(typeof SC_DISABLE_SPEEDY == "boolean" ? SC_DISABLE_SPEEDY : typeof process < "u" && process.env.REACT_APP_SC_DISABLE_SPEEDY !== void 0 && process.env.REACT_APP_SC_DISABLE_SPEEDY !== "" ? process.env.REACT_APP_SC_DISABLE_SPEEDY !== "false" && process.env.REACT_APP_SC_DISABLE_SPEEDY : typeof process < "u" && process.env.SC_DISABLE_SPEEDY !== void 0 && process.env.SC_DISABLE_SPEEDY !== "" ? process.env.SC_DISABLE_SPEEDY !== "false" && process.env.SC_DISABLE_SPEEDY : process.env.NODE_ENV !== "production"), _n = process.env.NODE_ENV !== "production" ? { 1: `Cannot create styled-component for component: %s.

`, 2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`, 3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`, 4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`, 5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`, 6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`, 7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n', 8: `ThemeProvider: Please make your "theme" prop an object.

`, 9: "Missing document `<head>`\n\n", 10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`, 11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`, 12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n", 13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`, 14: `ThemeProvider: "theme" prop is required.

`, 15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n", 16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`, 17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
` } : {};
function wn() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], r = [], t = 1, n = arguments.length; t < n; t += 1)
    r.push(t < 0 || arguments.length <= t ? void 0 : arguments[t]);
  return r.forEach(function(i) {
    e = e.replace(/%[a-z]/, i);
  }), e;
}
function Ye(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (t.length > 0 ? " Args: " + t.join(", ") : "")) : new Error(wn.apply(void 0, [_n[e]].concat(t)).trim());
}
var bn = function() {
  function e(t) {
    this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = t;
  }
  var r = e.prototype;
  return r.indexOfGroup = function(t) {
    for (var n = 0, i = 0; i < t; i++)
      n += this.groupSizes[i];
    return n;
  }, r.insertRules = function(t, n) {
    if (t >= this.groupSizes.length) {
      for (var i = this.groupSizes, s = i.length, c = s; t >= c; )
        (c <<= 1) < 0 && Ye(16, "" + t);
      this.groupSizes = new Uint32Array(c), this.groupSizes.set(i), this.length = c;
      for (var u = s; u < c; u++)
        this.groupSizes[u] = 0;
    }
    for (var f = this.indexOfGroup(t + 1), m = 0, E = n.length; m < E; m++)
      this.tag.insertRule(f, n[m]) && (this.groupSizes[t]++, f++);
  }, r.clearGroup = function(t) {
    if (t < this.length) {
      var n = this.groupSizes[t], i = this.indexOfGroup(t), s = i + n;
      this.groupSizes[t] = 0;
      for (var c = i; c < s; c++)
        this.tag.deleteRule(i);
    }
  }, r.getGroup = function(t) {
    var n = "";
    if (t >= this.length || this.groupSizes[t] === 0)
      return n;
    for (var i = this.groupSizes[t], s = this.indexOfGroup(t), c = s + i, u = s; u < c; u++)
      n += this.tag.getRule(u) + `/*!sc*/
`;
    return n;
  }, e;
}(), tt = /* @__PURE__ */ new Map(), nt = /* @__PURE__ */ new Map(), Be = 1, Xe = function(e) {
  if (tt.has(e))
    return tt.get(e);
  for (; nt.has(Be); )
    Be++;
  var r = Be++;
  return process.env.NODE_ENV !== "production" && ((0 | r) < 0 || r > 1 << 30) && Ye(16, "" + r), tt.set(e, r), nt.set(r, e), r;
}, Pn = function(e) {
  return nt.get(e);
}, xn = function(e, r) {
  r >= Be && (Be = r + 1), tt.set(e, r), nt.set(r, e);
}, On = "style[" + Fe + '][data-styled-version="5.3.3"]', Nn = new RegExp("^" + Fe + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), In = function(e, r, t) {
  for (var n, i = t.split(","), s = 0, c = i.length; s < c; s++)
    (n = i[s]) && e.registerName(r, n);
}, Dn = function(e, r) {
  for (var t = (r.textContent || "").split(`/*!sc*/
`), n = [], i = 0, s = t.length; i < s; i++) {
    var c = t[i].trim();
    if (c) {
      var u = c.match(Nn);
      if (u) {
        var f = 0 | parseInt(u[1], 10), m = u[2];
        f !== 0 && (xn(m, f), In(e, m, u[3]), e.getTag().insertRules(f, n)), n.length = 0;
      } else
        n.push(c);
    }
  }
}, Mn = function() {
  return typeof window < "u" && window.__webpack_nonce__ !== void 0 ? window.__webpack_nonce__ : null;
}, ir = function(e) {
  var r = document.head, t = e || r, n = document.createElement("style"), i = function(u) {
    for (var f = u.childNodes, m = f.length; m >= 0; m--) {
      var E = f[m];
      if (E && E.nodeType === 1 && E.hasAttribute(Fe))
        return E;
    }
  }(t), s = i !== void 0 ? i.nextSibling : null;
  n.setAttribute(Fe, "active"), n.setAttribute("data-styled-version", "5.3.3");
  var c = Mn();
  return c && n.setAttribute("nonce", c), t.insertBefore(n, s), n;
}, kn = function() {
  function e(t) {
    var n = this.element = ir(t);
    n.appendChild(document.createTextNode("")), this.sheet = function(i) {
      if (i.sheet)
        return i.sheet;
      for (var s = document.styleSheets, c = 0, u = s.length; c < u; c++) {
        var f = s[c];
        if (f.ownerNode === i)
          return f;
      }
      Ye(17);
    }(n), this.length = 0;
  }
  var r = e.prototype;
  return r.insertRule = function(t, n) {
    try {
      return this.sheet.insertRule(n, t), this.length++, !0;
    } catch {
      return !1;
    }
  }, r.deleteRule = function(t) {
    this.sheet.deleteRule(t), this.length--;
  }, r.getRule = function(t) {
    var n = this.sheet.cssRules[t];
    return n !== void 0 && typeof n.cssText == "string" ? n.cssText : "";
  }, e;
}(), Ln = function() {
  function e(t) {
    var n = this.element = ir(t);
    this.nodes = n.childNodes, this.length = 0;
  }
  var r = e.prototype;
  return r.insertRule = function(t, n) {
    if (t <= this.length && t >= 0) {
      var i = document.createTextNode(n), s = this.nodes[t];
      return this.element.insertBefore(i, s || null), this.length++, !0;
    }
    return !1;
  }, r.deleteRule = function(t) {
    this.element.removeChild(this.nodes[t]), this.length--;
  }, r.getRule = function(t) {
    return t < this.length ? this.nodes[t].textContent : "";
  }, e;
}(), $n = function() {
  function e(t) {
    this.rules = [], this.length = 0;
  }
  var r = e.prototype;
  return r.insertRule = function(t, n) {
    return t <= this.length && (this.rules.splice(t, 0, n), this.length++, !0);
  }, r.deleteRule = function(t) {
    this.rules.splice(t, 1), this.length--;
  }, r.getRule = function(t) {
    return t < this.length ? this.rules[t] : "";
  }, e;
}(), Vt = xt, Un = { isServer: !xt, useCSSOMInjection: !Rn }, sr = function() {
  function e(t, n, i) {
    t === void 0 && (t = Ce), n === void 0 && (n = {}), this.options = ge({}, Un, {}, t), this.gs = n, this.names = new Map(i), this.server = !!t.isServer, !this.server && xt && Vt && (Vt = !1, function(s) {
      for (var c = document.querySelectorAll(On), u = 0, f = c.length; u < f; u++) {
        var m = c[u];
        m && m.getAttribute(Fe) !== "active" && (Dn(s, m), m.parentNode && m.parentNode.removeChild(m));
      }
    }(this));
  }
  e.registerId = function(t) {
    return Xe(t);
  };
  var r = e.prototype;
  return r.reconstructWithOptions = function(t, n) {
    return n === void 0 && (n = !0), new e(ge({}, this.options, {}, t), this.gs, n && this.names || void 0);
  }, r.allocateGSInstance = function(t) {
    return this.gs[t] = (this.gs[t] || 0) + 1;
  }, r.getTag = function() {
    return this.tag || (this.tag = (i = (n = this.options).isServer, s = n.useCSSOMInjection, c = n.target, t = i ? new $n(c) : s ? new kn(c) : new Ln(c), new bn(t)));
    var t, n, i, s, c;
  }, r.hasNameForId = function(t, n) {
    return this.names.has(t) && this.names.get(t).has(n);
  }, r.registerName = function(t, n) {
    if (Xe(t), this.names.has(t))
      this.names.get(t).add(n);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(n), this.names.set(t, i);
    }
  }, r.insertRules = function(t, n, i) {
    this.registerName(t, n), this.getTag().insertRules(Xe(t), i);
  }, r.clearNames = function(t) {
    this.names.has(t) && this.names.get(t).clear();
  }, r.clearRules = function(t) {
    this.getTag().clearGroup(Xe(t)), this.clearNames(t);
  }, r.clearTag = function() {
    this.tag = void 0;
  }, r.toString = function() {
    return function(t) {
      for (var n = t.getTag(), i = n.length, s = "", c = 0; c < i; c++) {
        var u = Pn(c);
        if (u !== void 0) {
          var f = t.names.get(u), m = n.getGroup(c);
          if (f && m && f.size) {
            var E = Fe + ".g" + c + '[id="' + u + '"]', T = "";
            f !== void 0 && f.forEach(function(R) {
              R.length > 0 && (T += R + ",");
            }), s += "" + m + E + '{content:"' + T + `"}/*!sc*/
`;
          }
        }
      }
      return s;
    }(this);
  }, e;
}(), Fn = /(a)(d)/gi, Bt = function(e) {
  return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function St(e) {
  var r, t = "";
  for (r = Math.abs(e); r > 52; r = r / 52 | 0)
    t = Bt(r % 52) + t;
  return (Bt(r % 52) + t).replace(Fn, "$1-$2");
}
var xe = function(e, r) {
  for (var t = r.length; t; )
    e = 33 * e ^ r.charCodeAt(--t);
  return e;
}, cr = function(e) {
  return xe(5381, e);
};
function zn(e) {
  for (var r = 0; r < e.length; r += 1) {
    var t = e[r];
    if (He(t) && !Pt(t))
      return !1;
  }
  return !0;
}
var Yn = cr("5.3.3"), jn = function() {
  function e(r, t, n) {
    this.rules = r, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && (n === void 0 || n.isStatic) && zn(r), this.componentId = t, this.baseHash = xe(Yn, t), this.baseStyle = n, sr.registerId(t);
  }
  return e.prototype.generateAndInjectStyles = function(r, t, n) {
    var i = this.componentId, s = [];
    if (this.baseStyle && s.push(this.baseStyle.generateAndInjectStyles(r, t, n)), this.isStatic && !n.hash)
      if (this.staticRulesId && t.hasNameForId(i, this.staticRulesId))
        s.push(this.staticRulesId);
      else {
        var c = ze(this.rules, r, t, n).join(""), u = St(xe(this.baseHash, c) >>> 0);
        if (!t.hasNameForId(i, u)) {
          var f = n(c, "." + u, void 0, i);
          t.insertRules(i, u, f);
        }
        s.push(u), this.staticRulesId = u;
      }
    else {
      for (var m = this.rules.length, E = xe(this.baseHash, n.hash), T = "", R = 0; R < m; R++) {
        var x = this.rules[R];
        if (typeof x == "string")
          T += x, process.env.NODE_ENV !== "production" && (E = xe(E, x + R));
        else if (x) {
          var g = ze(x, r, t, n), o = Array.isArray(g) ? g.join("") : g;
          E = xe(E, o + R), T += o;
        }
      }
      if (T) {
        var v = St(E >>> 0);
        if (!t.hasNameForId(i, v)) {
          var N = n(T, "." + v, void 0, i);
          t.insertRules(i, v, N);
        }
        s.push(v);
      }
    }
    return s.join(" ");
  }, e;
}(), Gn = /^\s*\/\/.*$/gm, Vn = [":", "[", ".", "#"];
function Bn(e) {
  var r, t, n, i, s = e === void 0 ? Ce : e, c = s.options, u = c === void 0 ? Ce : c, f = s.plugins, m = f === void 0 ? rt : f, E = new cn(u), T = [], R = function(o) {
    function v(N) {
      if (N)
        try {
          o(N + "}");
        } catch {
        }
    }
    return function(N, _, b, A, d, B, se, q, W, le) {
      switch (N) {
        case 1:
          if (W === 0 && _.charCodeAt(0) === 64)
            return o(_ + ";"), "";
          break;
        case 2:
          if (q === 0)
            return _ + "/*|*/";
          break;
        case 3:
          switch (q) {
            case 102:
            case 112:
              return o(b[0] + _), "";
            default:
              return _ + (le === 0 ? "/*|*/" : "");
          }
        case -2:
          _.split("/*|*/}").forEach(v);
      }
    };
  }(function(o) {
    T.push(o);
  }), x = function(o, v, N) {
    return v === 0 && Vn.indexOf(N[t.length]) !== -1 || N.match(i) ? o : "." + r;
  };
  function g(o, v, N, _) {
    _ === void 0 && (_ = "&");
    var b = o.replace(Gn, ""), A = v && N ? N + " " + v + " { " + b + " }" : b;
    return r = _, t = v, n = new RegExp("\\" + t + "\\b", "g"), i = new RegExp("(\\" + t + "\\b){2,}"), E(N || !v ? "" : v, A);
  }
  return E.use([].concat(m, [function(o, v, N) {
    o === 2 && N.length && N[0].lastIndexOf(t) > 0 && (N[0] = N[0].replace(n, x));
  }, R, function(o) {
    if (o === -2) {
      var v = T;
      return T = [], v;
    }
  }])), g.hash = m.length ? m.reduce(function(o, v) {
    return v.name || Ye(15), xe(o, v.name);
  }, 5381).toString() : "", g;
}
var lr = ot.createContext();
lr.Consumer;
var dr = ot.createContext(), Hn = (dr.Consumer, new sr()), Et = Bn();
function Wn() {
  return me(lr) || Hn;
}
function Kn() {
  return me(dr) || Et;
}
var Xn = function() {
  function e(r, t) {
    var n = this;
    this.inject = function(i, s) {
      s === void 0 && (s = Et);
      var c = n.name + s.hash;
      i.hasNameForId(n.id, c) || i.insertRules(n.id, c, s(n.rules, c, "@keyframes"));
    }, this.toString = function() {
      return Ye(12, String(n.name));
    }, this.name = r, this.id = "sc-keyframes-" + r, this.rules = t;
  }
  return e.prototype.getName = function(r) {
    return r === void 0 && (r = Et), this.name + r.hash;
  }, e;
}(), qn = /([A-Z])/, Qn = /([A-Z])/g, Zn = /^ms-/, Jn = function(e) {
  return "-" + e.toLowerCase();
};
function Ht(e) {
  return qn.test(e) ? e.replace(Qn, Jn).replace(Zn, "-ms-") : e;
}
var Wt = function(e) {
  return e == null || e === !1 || e === "";
};
function ze(e, r, t, n) {
  if (Array.isArray(e)) {
    for (var i, s = [], c = 0, u = e.length; c < u; c += 1)
      (i = ze(e[c], r, t, n)) !== "" && (Array.isArray(i) ? s.push.apply(s, i) : s.push(i));
    return s;
  }
  if (Wt(e))
    return "";
  if (Pt(e))
    return "." + e.styledComponentId;
  if (He(e)) {
    if (typeof (m = e) != "function" || m.prototype && m.prototype.isReactComponent || !r)
      return e;
    var f = e(r);
    return process.env.NODE_ENV !== "production" && _t.isElement(f) && console.warn(yt(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), ze(f, r, t, n);
  }
  var m;
  return e instanceof Xn ? t ? (e.inject(t, n), e.getName(n)) : e : gt(e) ? function E(T, R) {
    var x, g, o = [];
    for (var v in T)
      T.hasOwnProperty(v) && !Wt(T[v]) && (Array.isArray(T[v]) && T[v].isCss || He(T[v]) ? o.push(Ht(v) + ":", T[v], ";") : gt(T[v]) ? o.push.apply(o, E(T[v], v)) : o.push(Ht(v) + ": " + (x = v, (g = T[v]) == null || typeof g == "boolean" || g === "" ? "" : typeof g != "number" || g === 0 || x in ln ? String(g).trim() : g + "px") + ";"));
    return R ? [R + " {"].concat(o, ["}"]) : o;
  }(e) : e.toString();
}
var Kt = function(e) {
  return Array.isArray(e) && (e.isCss = !0), e;
};
function eo(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  return He(e) || gt(e) ? Kt(ze(Gt(rt, [e].concat(t)))) : t.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : Kt(ze(Gt(e, t)));
}
var Xt = /invalid hook call/i, qe = /* @__PURE__ */ new Set(), to = function(e, r) {
  if (process.env.NODE_ENV !== "production") {
    var t = "The component " + e + (r ? ' with the id of "' + r + '"' : "") + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`, n = console.error;
    try {
      var i = !0;
      console.error = function(s) {
        if (Xt.test(s))
          i = !1, qe.delete(t);
        else {
          for (var c = arguments.length, u = new Array(c > 1 ? c - 1 : 0), f = 1; f < c; f++)
            u[f - 1] = arguments[f];
          n.apply(void 0, [s].concat(u));
        }
      }, Cr(), i && !qe.has(t) && (console.warn(t), qe.add(t));
    } catch (s) {
      Xt.test(s.message) && qe.delete(t);
    } finally {
      console.error = n;
    }
  }
}, ro = function(e, r, t) {
  return t === void 0 && (t = Ce), e.theme !== t.theme && e.theme || r || t.theme;
}, no = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, oo = /(^-|-$)/g;
function ut(e) {
  return e.replace(no, "-").replace(oo, "");
}
var ao = function(e) {
  return St(cr(e) >>> 0);
};
function Qe(e) {
  return typeof e == "string" && (process.env.NODE_ENV === "production" || e.charAt(0) === e.charAt(0).toLowerCase());
}
var vt = function(e) {
  return typeof e == "function" || typeof e == "object" && e !== null && !Array.isArray(e);
}, io = function(e) {
  return e !== "__proto__" && e !== "constructor" && e !== "prototype";
};
function so(e, r, t) {
  var n = e[t];
  vt(r) && vt(n) ? ur(n, r) : e[t] = r;
}
function ur(e) {
  for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
    t[n - 1] = arguments[n];
  for (var i = 0, s = t; i < s.length; i++) {
    var c = s[i];
    if (vt(c))
      for (var u in c)
        io(u) && so(e, c[u], u);
  }
  return e;
}
var pr = ot.createContext();
pr.Consumer;
var pt = {};
function fr(e, r, t) {
  var n = Pt(e), i = !Qe(e), s = r.attrs, c = s === void 0 ? rt : s, u = r.componentId, f = u === void 0 ? function(_, b) {
    var A = typeof _ != "string" ? "sc" : ut(_);
    pt[A] = (pt[A] || 0) + 1;
    var d = A + "-" + ao("5.3.3" + A + pt[A]);
    return b ? b + "-" + d : d;
  }(r.displayName, r.parentComponentId) : u, m = r.displayName, E = m === void 0 ? function(_) {
    return Qe(_) ? "styled." + _ : "Styled(" + yt(_) + ")";
  }(e) : m, T = r.displayName && r.componentId ? ut(r.displayName) + "-" + r.componentId : r.componentId || f, R = n && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, x = r.shouldForwardProp;
  n && e.shouldForwardProp && (x = r.shouldForwardProp ? function(_, b, A) {
    return e.shouldForwardProp(_, b, A) && r.shouldForwardProp(_, b, A);
  } : e.shouldForwardProp);
  var g, o = new jn(t, T, n ? e.componentStyle : void 0), v = o.isStatic && c.length === 0, N = function(_, b) {
    return function(A, d, B, se) {
      var q = A.attrs, W = A.componentStyle, le = A.defaultProps, ae = A.foldedComponentIds, te = A.shouldForwardProp, ne = A.styledComponentId, ce = A.target;
      process.env.NODE_ENV !== "production" && Ot(ne);
      var J = function(P, a, D) {
        P === void 0 && (P = Ce);
        var p = ge({}, a, { theme: P }), z = {};
        return D.forEach(function(M) {
          var I, l, j, H = M;
          for (I in He(H) && (H = H(p)), H)
            p[I] = z[I] = I === "className" ? (l = z[I], j = H[I], l && j ? l + " " + j : l || j) : H[I];
        }), [p, z];
      }(ro(d, me(pr), le) || Ce, d, q), we = J[0], ie = J[1], re = function(P, a, D, p) {
        var z = Wn(), M = Kn(), I = a ? P.generateAndInjectStyles(Ce, z, M) : P.generateAndInjectStyles(D, z, M);
        return process.env.NODE_ENV !== "production" && Ot(I), process.env.NODE_ENV !== "production" && !a && p && p(I), I;
      }(W, se, we, process.env.NODE_ENV !== "production" ? A.warnTooManyClasses : void 0), be = B, he = ie.$as || d.$as || ie.as || d.as || ce, Pe = Qe(he), S = ie !== d ? ge({}, d, {}, ie) : d, h = {};
      for (var y in S)
        y[0] !== "$" && y !== "as" && (y === "forwardedAs" ? h.as = S[y] : (te ? te(y, $t, he) : !Pe || $t(y)) && (h[y] = S[y]));
      return d.style && ie.style !== d.style && (h.style = ge({}, d.style, {}, ie.style)), h.className = Array.prototype.concat(ae, ne, re !== ne ? re : null, d.className, ie.className).filter(Boolean).join(" "), h.ref = be, Tr(he, h);
    }(g, _, b, v);
  };
  return N.displayName = E, (g = ot.forwardRef(N)).attrs = R, g.componentStyle = o, g.displayName = E, g.shouldForwardProp = x, g.foldedComponentIds = n ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : rt, g.styledComponentId = T, g.target = n ? e.target : e, g.withComponent = function(_) {
    var b = r.componentId, A = function(B, se) {
      if (B == null)
        return {};
      var q, W, le = {}, ae = Object.keys(B);
      for (W = 0; W < ae.length; W++)
        q = ae[W], se.indexOf(q) >= 0 || (le[q] = B[q]);
      return le;
    }(r, ["componentId"]), d = b && b + "-" + (Qe(_) ? _ : ut(yt(_)));
    return fr(_, ge({}, A, { attrs: R, componentId: d }), t);
  }, Object.defineProperty(g, "defaultProps", { get: function() {
    return this._foldedDefaultProps;
  }, set: function(_) {
    this._foldedDefaultProps = n ? ur({}, e.defaultProps, _) : _;
  } }), process.env.NODE_ENV !== "production" && (to(E, T), g.warnTooManyClasses = function(_, b) {
    var A = {}, d = !1;
    return function(B) {
      if (!d && (A[B] = !0, Object.keys(A).length >= 200)) {
        var se = b ? ' with the id of "' + b + '"' : "";
        console.warn("Over 200 classes were generated for component " + _ + se + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), d = !0, A = {};
      }
    };
  }(E, T)), g.toString = function() {
    return "." + g.styledComponentId;
  }, i && An(g, e, { attrs: !0, componentStyle: !0, displayName: !0, foldedComponentIds: !0, shouldForwardProp: !0, styledComponentId: !0, target: !0, withComponent: !0 }), g;
}
var Ct = function(e) {
  return function r(t, n, i) {
    if (i === void 0 && (i = Ce), !_t.isValidElementType(n))
      return Ye(1, String(n));
    var s = function() {
      return t(n, i, eo.apply(void 0, arguments));
    };
    return s.withConfig = function(c) {
      return r(t, n, ge({}, i, {}, c));
    }, s.attrs = function(c) {
      return r(t, n, ge({}, i, { attrs: Array.prototype.concat(i.attrs, c).filter(Boolean) }));
    }, s;
  }(fr, e);
};
["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "marquee", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "marker", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "textPath", "tspan"].forEach(function(e) {
  Ct[e] = Ct(e);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`), process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const V = Ct, co = V.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  padding: 152px 132px ${fe.xxlarge}px;
  @media ${Re.lessThanSmall} {
    padding: 112px ${fe.base}px ${fe.xxlarge}px;
  }
`, lo = V.img``, uo = V.p`
  font-weight: ${Ie.bold};
  margin-top: ${fe.xlarge}px;
  font-size: ${ye.medium}px;
  text-align: center;
  line-height: 28px;
  margin: ${fe.large}px 0;
  width: 504px;
  @media ${Re.lessThanSmall} {
    width: 343px;
  }
`, po = V(At)`
  font-weight: ${Ie.regular};
  font-size: ${ye.root}px;
  text-align: center;
  width: 504px;
  line-height: 24px;
  @media ${Re.lessThanSmall} {
    width: 343px;
  }
`, mr = () => {
  const e = it(), { assets: r } = e.hosts, { t } = Se(Ue), { triggerAnalyticsEvent: n } = at();
  return $e(() => {
    n({
      pageKind: K.CUSTOM_CARD,
      pageFunction: Y.CUSTOM_CARD,
      pageSubFunction: ue.STATUSES,
      pageName: X.TECHNICAL_ERROR,
      messageType: ke.API_FAILURE,
      errorMessage: Le.TECHNICAL_ERROR
    });
  }, []), /* @__PURE__ */ oe(co, { children: [
    /* @__PURE__ */ C(lo, { alt: "", src: `${r}${Zr}` }),
    /* @__PURE__ */ C(uo, { "data-cy": "technical-error-title", children: /* @__PURE__ */ C(
      It,
      {
        i18nKey: "headings.technicalErrorTitle",
        ns: Ue,
        t
      }
    ) }),
    /* @__PURE__ */ C(po, { "data-cy": "technical-error-description", children: /* @__PURE__ */ C(It, { i18nKey: "labels.tryAgainText" }) })
  ] });
};
class hr extends Ar {
  constructor(r) {
    super(r), this.state = {
      hasError: !1,
      error: null
    };
  }
  static getDerivedStateFromError(r) {
    return { hasError: !0, error: r };
  }
  componentDidCatch(r, t) {
    this.setState({ error: r }), console.error("Uncaught error:", r, t);
  }
  render() {
    const { hasError: r, error: t } = this.state, { children: n } = this.props;
    return r && t ? /* @__PURE__ */ C(mr, {}) : n;
  }
}
hr.contextType = De;
const Ze = {
  CARD_PRINTING_INPROGRESS: "CARD_PRINTING_INPROGRESS",
  CARD_SENT: "CARD_SENT",
  PENDING: "PENDING",
  REJECTED: "REJECTED"
}, st = (e, r) => {
  const t = me(Rt), n = kr();
  if (!t)
    throw new Error("No config");
  return {
    config: t,
    queryOptions: {
      ...n.getQueryDefaults(),
      enabled: e,
      ...r
    }
  };
}, Me = (e = !0) => {
  const { selectedAccountId: r } = me(De), t = st(e);
  return Nr({
    keyProps: {
      accountId: r,
      /**
       * AccountIdType is needed in order to convert them to usable account numbers
       * APIs internally support "guid|account as string" and needs us to explicitly pass in the type
       * since account numbers we get are encoded as guid from the accounts api
       */
      accountIdType: "guid"
    },
    ...t
  });
}, gr = (e = !0) => {
  const { selectedAccountId: r } = me(De), t = st(e);
  return Ir({
    keyProps: {
      accountId: r,
      /**
       * AccountIdType is needed in order to convert them to usable account numbers
       * APIs internally support "guid|account as string" and needs us to explicitly pass in the type
       * since account numbers we get are encoded as guid from the accounts api
       */
      accountIdType: "guid"
    },
    ...t
  });
}, fo = (e = !0) => {
  const { selectedAccountId: r } = me(De), t = st(e);
  return Dr({
    keyProps: {
      accountId: r,
      /**
       * AccountIdType is needed in order to convert them to usable account numbers
       * APIs internally support "guid|account as string" and needs us to explicitly pass in the type
       * since account numbers we get are encoded as guid from the accounts api
       */
      accountIdType: "guid"
    },
    ...t
  });
}, mo = (e = !0) => {
  const { selectedAccountId: r } = me(De), t = st(e);
  return Mr({
    keyProps: {
      accountId: r,
      /**
       * AccountIdType is needed in order to convert them to usable account numbers
       * APIs internally support "guid|account as string" and needs us to explicitly pass in the type
       * since account numbers we get are encoded as guid from the accounts api
       */
      accountIdType: "guid"
    },
    ...t
  });
}, ho = V.div`
  position: sticky;
  width: 100%;
  bottom: 0;
  margin-top: auto;
`, je = (e) => /* @__PURE__ */ C(ho, { children: /* @__PURE__ */ C($r, { dataCy: "drawer-footer", ...e }, "footer") }), go = V.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  padding: 152px 132px ${fe.xxlarge}px;
  @media ${Re.lessThanSmall} {
    padding: 112px ${fe.base}px ${fe.xxlarge}px;
  }
`, yo = V.div`
  display: block;
`, So = V.img`
  margin: 0 auto;
`, Eo = V.p`
  font-weight: ${Ie.bold};
  margin-top: ${ye.xxLarge}px;
  font-size: ${ye.medium}px;
  text-align: center;
  margin: ${fe.large}px 0;
  max-width: 504px;
`, qt = V(At)`
  font-weight: ${Ie.regular};
  font-size: ${ye.root}px;
  text-align: center;
  max-width: 504px;
`, ct = ({
  screenVerbiageDefinitions: e,
  imagePath: r,
  portfolioName: t
}) => {
  const n = it(), { assets: i } = n.hosts;
  return /* @__PURE__ */ oe(go, { children: [
    /* @__PURE__ */ C(So, { alt: "", src: `${i}${r}` }),
    /* @__PURE__ */ C(Eo, { "data-cy": "screen-title", children: pe.t(e.screenTitle, {
      portfolioName: t
    }) }),
    /* @__PURE__ */ oe(yo, { children: [
      /* @__PURE__ */ C(qt, { "data-cy": "screen-primary-description", children: pe.t(e.screenPrimaryDescription, {
        portfolioName: t
      }) }),
      /* @__PURE__ */ C(et, {}),
      /* @__PURE__ */ C(qt, { "data-cy": "screen-secondary-description", children: pe.t(e.screenSecondaryDescription, {
        portfolioName: t
      }) })
    ] })
  ] });
}, vo = {
  screenTitle: "screen.cardPrintingInProgress.title",
  screenPrimaryDescription: "screen.cardPrintingInProgress.primaryDescriptionText",
  screenSecondaryDescription: "screen.common.secondaryDescriptionText"
}, Co = () => {
  const { data: e } = Me(), { t: r } = Se(), { handleModalClose: t } = _e(), n = {
    dataCy: "drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: t,
    primaryText: r("button.closeButtonText"),
    dataPrimaryReason: We,
    dataPrimaryObject: Te
  };
  return e ? /* @__PURE__ */ oe(Ae, { children: [
    /* @__PURE__ */ C(
      ct,
      {
        imagePath: nr,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: vo
      }
    ),
    /* @__PURE__ */ C(je, { ...n })
  ] }) : null;
}, To = {
  screenTitle: "screen.cardSent.title",
  screenPrimaryDescription: "screen.cardSent.primaryDescriptionText",
  screenSecondaryDescription: "screen.common.secondaryDescriptionText"
}, Ao = () => {
  const { data: e } = Me(), { t: r } = Se(), { handleModalClose: t } = _e(), n = {
    dataCy: "drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: t,
    primaryText: r("button.closeButtonText"),
    dataPrimaryReason: We,
    dataPrimaryObject: Te
  };
  return e ? /* @__PURE__ */ oe(Ae, { children: [
    /* @__PURE__ */ C(
      ct,
      {
        imagePath: nr,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: To
      }
    ),
    /* @__PURE__ */ C(je, { ...n })
  ] }) : null;
}, Qt = () => {
  const { t: e } = Se(), { handleModalClose: r } = _e(), t = {
    dataCy: "drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: r,
    primaryText: e("button.closeButtonText"),
    dataPrimaryReason: We,
    dataPrimaryObject: Te
  };
  return /* @__PURE__ */ oe(Ae, { children: [
    /* @__PURE__ */ C(mr, {}),
    /* @__PURE__ */ C(je, { ...t })
  ] });
};
function Ro(e) {
  if (e) {
    if (e.product.type === "DUAL_CARD")
      return rn;
    if (e.product.type === "PRIVATE_LABEL")
      return nn;
  }
  return "";
}
const ft = "customCardArtAction", yr = () => ({
  setSessionAction: (n) => {
    sessionStorage.setItem(ft, n);
  },
  getSessionAction: () => sessionStorage.getItem(ft),
  removeSessionAction: () => {
    sessionStorage.removeItem(ft);
  }
}), Sr = V.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`, _o = V(Sr)`
  background: radial-gradient(#00a98f, #008479);
  height: 490px;
  padding: 24px 0;
  position: relative;
  text-align: center;
  width: 100%;
  @media ${Re.lessThanSmall} {
    height: 278px;
  }
`, wo = V.p`
  font-weight: ${Ie.bold};
  font-size: ${ye.xLarge}px;
  text-align: center;
  color: ${er.white};
  line-height: ${Dt.large};
  margin: auto;
  max-width: 504px;
  width: 100%;
  white-space: break-spaces;
  position: absolute;
  @media ${Re.lessThanSmall} {
    font-size: ${ye.medium}px;
    line-height: ${Dt.root};
    max-width: 247px;
  }
`, bo = V.img`
  margin: 0 auto;
  position: absolute;
  bottom: 0px;
  width: 100%;
  max-width: 365px;
  height: 308px;
  @media ${Re.lessThanSmall} {
    max-width: 246px;
    height: 156px;
  }
`, Po = V.img`
  margin: 0 auto;
  position: absolute;
  bottom: 20px;
  width: 100%;
  max-width: 504px;
  height: 318px;
  @media ${Re.lessThanSmall} {
    bottom: 9px;
    max-width: 247px;
    height: 156px;
  }
`, xo = V.div`
  display: block;
  padding: 16px;
`;
V.img`
  margin: 0 auto;
`;
const Je = V(At)`
  font-weight: ${Ie.regular};
  font-size: ${ye.root}px;
  max-width: 504px;
  white-space: pre-line;
`, Oo = ({
  screenVerbiageDefinitions: e,
  innerFrameImagePath: r,
  frameImagePath: t,
  portfolioName: n
}) => {
  const i = it(), { assets: s } = i.hosts;
  return /* @__PURE__ */ oe(Sr, { children: [
    /* @__PURE__ */ oe(_o, { children: [
      /* @__PURE__ */ C(wo, { "data-cy": "screen-title", children: pe.t(e.screenTitle, {
        portfolioName: n
      }) }),
      /* @__PURE__ */ C(bo, { src: `${s}${r}` }),
      /* @__PURE__ */ C(Po, { src: `${s}${t}` })
    ] }),
    /* @__PURE__ */ oe(xo, { "data-cy": "screen-getStarted-description", children: [
      /* @__PURE__ */ C(Je, { "data-cy": "screen-offering-description", children: pe.t(e.screenOfferingDescription, {
        portfolioName: n
      }) }),
      /* @__PURE__ */ C(et, {}),
      /* @__PURE__ */ C(Je, { "data-cy": "screen-process-description", children: pe.t(e.screenProcessDescription, {
        portfolioName: n
      }) }),
      /* @__PURE__ */ C(et, {}),
      /* @__PURE__ */ C(Je, { "data-cy": "screen-extraNote-description", children: pe.t(e.screenExtraNoteDescription, {
        portfolioName: n
      }) }),
      /* @__PURE__ */ C(et, {}),
      /* @__PURE__ */ C(Je, { "data-cy": "screen-customizeNow-description", children: pe.t(e.screenCustomizeNowDescription, {
        portfolioName: n
      }) })
    ] })
  ] });
}, No = {
  screenTitle: "screen.getStarted.title",
  screenOfferingDescription: "screen.getStarted.offeringDescription",
  screenProcessDescription: "screen.getStarted.processDescription",
  screenExtraNoteDescription: "screen.getStarted.extraNoteDescription",
  screenCustomizeNowDescription: "screen.getStarted.customizeNowDescription"
}, Io = () => {
  const { data: e } = Me(), { t: r } = Se(), {
    handleModalClose: t,
    transition: n,
    reset: i
  } = _e(), { authenticationRedirect: s } = at(), { setSessionAction: c } = yr(), { error: u, isFetching: f } = fo(), E = {
    dataCy: "getStarted-drawer-footer",
    handlePrimaryButton: async () => {
      u?.response?.status === 403 && (c("stepUp"), i(), s()), u || n("manageCardArt");
    },
    isPrimaryLoading: f,
    primaryText: r("button.getStarted"),
    dataPrimaryObject: Te,
    dataPrimaryReason: jr,
    secondaryText: r("button.cancelButtonText"),
    dataSecondaryObject: Te,
    dataSecondaryReason: Yr,
    handleSecondaryButton: t,
    secondaryButtonType: "ghost"
  };
  return e ? /* @__PURE__ */ oe(Ae, { children: [
    /* @__PURE__ */ C(
      Oo,
      {
        frameImagePath: Ro(e),
        innerFrameImagePath: tn,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: No
      }
    ),
    /* @__PURE__ */ C(je, { ...E })
  ] }) : null;
}, Do = {
  en: "en-US",
  es: "es-ES"
}, Oe = {
  COMPLETE: "complete",
  COMPLETE_CLOSE: "complete-close",
  ERROR: "error",
  EXIT_SUCCESS: "exit success",
  RESET_IMAGE: "reset image"
}, Mo = [
  Oe.COMPLETE,
  Oe.COMPLETE_CLOSE,
  Oe.ERROR,
  Oe.EXIT_SUCCESS,
  Oe.RESET_IMAGE
], ko = {
  exit: {
    errorMessage: Le.EXIT_CONFIRMATION,
    message: Ne.LOSE_ALL_PROGRESS,
    messageType: ke.EXIT_CONFIRMATION,
    pageFunction: Y.CUSTOM_CARD,
    pageKind: K.CUSTOM_CARD,
    pageSubFunction: ue.EXIT,
    pageName: X.CONFIRMATION
  },
  editor: {
    pageFunction: Y.CUSTOM_CARD,
    pageKind: K.CUSTOM_CARD,
    pageSubFunction: "",
    pageName: X.EDITOR
  },
  instructions: {
    pageFunction: Y.CUSTOM_CARD,
    pageKind: K.CUSTOM_CARD,
    pageSubFunction: ue.GUIDELINE,
    pageName: X.VIEW
  },
  "image coverage error": {
    message: Ne.IMAGE_FILL_CONTAINER,
    pageFunction: Y.CUSTOM_CARD,
    pageKind: K.CUSTOM_CARD,
    pageName: X.EDITOR
  },
  preview: {
    pageFunction: Y.CUSTOM_CARD,
    pageKind: K.CUSTOM_CARD,
    pageSubFunction: ue.PLACE_ORDER,
    pageName: X.PREVIEW
  },
  reset: {
    errorMessage: Le.IMAGE_RESET_CONFIRMATION,
    message: Ne.CHANGES_UNDONE,
    messageType: ke.IMAGE_RESET_CONFIRMATION,
    pageFunction: Y.CUSTOM_CARD,
    pageKind: K.CUSTOM_CARD,
    pageSubFunction: ue.RESET,
    pageName: X.CONFIRMATION
  },
  start: {
    pageFunction: Y.CUSTOM_CARD,
    pageKind: K.CUSTOM_CARD,
    pageSubFunction: ue.INSTRUCTIONS,
    pageName: X.START
  },
  "error maxSize": {
    ErrorMessage: Le.IMAGE_TOO_LARGE,
    MessageType: ke.VALIDATION_FAILURE,
    PageFunction: Y.CUSTOM_CARD,
    PageKind: K.CUSTOM_CARD,
    pageName: X.ERROR
  },
  "error minSize": {
    ErrorMessage: Le.IMAGE_TOO_SMALL,
    MessageType: ke.VALIDATION_FAILURE,
    PageFunction: Y.CUSTOM_CARD,
    PageKind: K.CUSTOM_CARD,
    pageName: X.ERROR
  },
  "error notSupported": {
    ErrorMessage: Le.FILE_FORMAT_NOT_SUPPORTED,
    MessageType: ke.VALIDATION_FAILURE,
    PageFunction: Y.CUSTOM_CARD,
    PageKind: K.CUSTOM_CARD,
    pageName: X.ERROR
  }
}, Lo = async (e) => {
  const r = await fetch(e);
  if (!r.ok)
    throw new Ur(r);
  return await r.json();
}, $o = (e) => Lr(
  ["thalesEnvServiceFileData", e],
  () => Lo(e)
), Uo = V.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${fe.xxlarge}px;
`, Fo = V.span`
  margin-top: ${fe.large}px;
  font-size: ${ye.medium}px;
  font-weight: ${Ie.bold};
  line-height: 1.4;
  color: ${er.black};
`, Er = (e) => {
  const { loadingText: r } = e;
  return /* @__PURE__ */ oe(Uo, { children: [
    /* @__PURE__ */ C(Fr, { size: 7 }),
    /* @__PURE__ */ C(Fo, { "data-cy": "loader-text", children: r })
  ] });
}, zo = V.div`
  height: '100vh';
  img {
    display: inline;
  }
`;
let ve;
const Yo = () => {
  const { lang: e, hosts: r } = it(), { serviceFile: t } = r, { envProp: n, triggerAnalyticsEvent: i } = at(), { transition: s, handleModalClose: c } = _e(), [u, f] = Nt(!0), [m, E] = Nt(!1), { t: T } = Se(), { data: R, isFetching: x } = $o(`${t}`), { data: g } = gr(), { data: o } = Me(), { data: v } = mo(), N = o?.product.type, _ = v?.profile?.["cipher.email"], b = () => R ? n === "production" ? {
    scriptURL: R.production.scriptURL,
    styleSheetURL: R.production.styleSheetURL,
    designerEnvironmentOption: R.production.designerEnvironmentOption,
    handoverKey: R.production.handoverKey
  } : {
    scriptURL: R.development.scriptURL,
    styleSheetURL: R.development.styleSheetURL,
    designerEnvironmentOption: R.development.designerEnvironmentOption,
    handoverKey: R.development.handoverKey
  } : {
    scriptURL: "",
    styleSheetURL: "",
    designerEnvironmentOption: "",
    handoverKey: {
      DUAL_CARD: "",
      PRIVATE_LABEL: ""
    }
  }, { handoverKey: A, scriptURL: d, styleSheetURL: B, designerEnvironmentOption: se } = b(), q = Rr(() => {
    ve = document.createElement("script"), ve.async = !0, ve.src = d, document.body.appendChild(ve);
    const W = document.createElement("link");
    W.href = B, W.rel = "stylesheet", document.body.appendChild(W), ve.onload = () => {
      f(!1), i({
        pageKind: K.CUSTOM_CARD,
        pageFunction: Y.CUSTOM_CARD,
        pageSubFunction: ue.STATUSES,
        pageName: X.START
      });
    }, ve.onerror = () => {
      E(!0), s("error");
    };
  }, [R]);
  return $e(() => {
    if (!u && !m) {
      const W = window.aam;
      new W.designer({
        callbacks: {
          onSubmit: () => {
            i({
              message: Ne.SENT_FOR_APPROVAL,
              pageFunction: Y.CUSTOM_CARD,
              pageKind: K.CUSTOM_CARD,
              pageName: X.COMPLETE
            });
          },
          onViewChange: (ae) => {
            (ae === Oe.EXIT_SUCCESS || ae === Oe.COMPLETE_CLOSE) && c(), !Mo.includes(ae) && i(ko[ae]);
          }
        },
        options: {
          detectMobile: !0,
          env: se,
          emailAddress: _,
          handback: {
            enabled: !1
          },
          languageId: Do[e],
          passthrough: {
            obfuscatedAccountId: g?.uniqueAccountId
          }
        }
      }).start();
    }
  }, [u, m, e]), $e(() => (x || q(), () => {
    ve && document.body.removeChild(ve);
  }), [x, q]), /* @__PURE__ */ C(Ae, { children: x ? /* @__PURE__ */ C(Er, { loadingText: T("labels.customCardArtLoaderText") }) : /* @__PURE__ */ C(
    zo,
    {
      className: "my-container",
      "data-cy": "designer-container",
      id: "designerContainer",
      children: /* @__PURE__ */ C(
        "div",
        {
          className: "aam-designer-init",
          "data-handoverkey": A[N],
          id: "aam-designer"
        }
      )
    }
  ) });
}, jo = () => /* @__PURE__ */ C(Yo, {}), Go = {
  screenTitle: "screen.pending.title",
  screenPrimaryDescription: "screen.pending.primaryDescriptionText",
  screenSecondaryDescription: "screen.common.secondaryDescriptionText"
}, Vo = () => {
  const { data: e } = Me(), { t: r } = Se(), { handleModalClose: t } = _e(), n = {
    dataCy: "drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: t,
    primaryText: r("button.closeButtonText"),
    dataPrimaryReason: We,
    dataPrimaryObject: Te
  };
  return e ? /* @__PURE__ */ oe(Ae, { children: [
    /* @__PURE__ */ C(
      ct,
      {
        imagePath: en,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: Go
      }
    ),
    /* @__PURE__ */ C(je, { ...n })
  ] }) : null;
}, Bo = {
  screenTitle: "screen.rejected.title",
  screenPrimaryDescription: "screen.rejected.primaryDescriptionText",
  screenSecondaryDescription: "screen.common.secondaryDescriptionText"
}, Ho = () => {
  const { data: e } = Me(), { t: r } = Se(), { handleModalClose: t, transition: n } = _e(), i = () => {
    n("getStarted");
  }, s = {
    dataCy: "rejected-drawer-footer",
    dataType: Y.CUSTOM_CARD,
    handlePrimaryButton: i,
    primaryText: r("button.uploadNewImage"),
    dataPrimaryReason: Vr,
    dataPrimaryObject: Te,
    secondaryText: r("button.closeButtonText"),
    handleSecondaryButton: t,
    secondaryButtonType: "ghost",
    dataSecondaryReason: We,
    dataSecondaryObject: Te
  };
  return e ? /* @__PURE__ */ oe(Ae, { children: [
    /* @__PURE__ */ C(
      ct,
      {
        imagePath: Jr,
        portfolioName: e.product.portfolio,
        screenVerbiageDefinitions: Bo
      }
    ),
    /* @__PURE__ */ C(je, { ...s })
  ] }) : null;
}, Wo = (e) => {
  const r = {
    [Ze.PENDING]: "pending",
    [Ze.REJECTED]: "rejected",
    [Ze.CARD_PRINTING_INPROGRESS]: "cardPrintingInProgress",
    [Ze.CARD_SENT]: "cardSent"
  };
  return e && r[e] ? r[e] : "getStarted";
}, Ko = (e) => {
  const r = {
    getStarted: Io,
    pending: Vo,
    cardPrintingInProgress: Co,
    cardSent: Ao,
    manageCardArt: jo,
    rejected: Ho,
    error: Qt
  };
  return e in r ? r[e] : Qt;
}, Zt = "otpErrorCallbackParams", Xo = () => ({ getStepUpError: () => sessionStorage.getItem(Zt), removeStepUpError: () => {
  sessionStorage.removeItem(Zt);
} }), qo = ({
  containerId: e,
  selectedAccountId: r
}) => {
  const { t } = Se(Ue), { activeScreen: n, handleModalClose: i, isModalOpen: s, transition: c, reset: u } = _e(), { getSessionAction: f, removeSessionAction: m } = yr(), { getStepUpError: E, removeStepUpError: T } = Xo(), { data: R } = Me(), {
    data: x,
    isFetching: g,
    isError: o,
    refetch: v
  } = gr();
  $e(() => {
    v();
  }, []), $e(() => {
    const b = x?.status;
    if (s && !g) {
      if (o || b === void 0) {
        c("error");
        return;
      }
      const A = f();
      m();
      const d = E();
      if (T(), A === "stepUp" && !d) {
        c("manageCardArt");
        return;
      }
      const B = Wo(b);
      c(B);
    }
    return () => {
      u();
    };
  }, [x?.status, g, s]);
  const N = n === "manageCardArt", _ = n && Ko(n);
  return /* @__PURE__ */ C(
    xr,
    {
      ariaLabel: t("title.drawerTitle", {
        portfolioName: R?.product.portfolio
      }),
      containerId: e,
      "data-cy": "custom-card-art-modal",
      escapeModalHandler: N ? () => null : i,
      header: N ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        /* @__PURE__ */ C(Ae, {})
      ) : /* @__PURE__ */ C(
        Or,
        {
          closeButtonAriaLabel: "Close Dialog",
          closeModal: i,
          content: t("title.drawerTitle", {
            portfolioName: R?.product.portfolio
          }),
          "data-cy": "custom-card-art-drawer-name",
          dataReason: Gr,
          dataType: Y.CUSTOM_CARD
        }
      ),
      id: `custom-card-art-modal-${r}`,
      isOpen: s,
      children: _ && /* @__PURE__ */ C(_, {}) || /* @__PURE__ */ C(
        Er,
        {
          loadingText: t("labels.customCardArtLoaderText")
        },
        "screen"
      )
    }
  );
}, ma = ({
  closeModal: e,
  containerId: r,
  envProp: t,
  isModalOpen: n,
  mfeConfig: i,
  selectedAccountId: s,
  triggerAnalyticsEvent: c,
  authenticationRedirect: u
}) => {
  $e(() => {
    pe.changeLanguage(i.lang);
  }, [i.lang]);
  const f = Jt(
    () => ({
      envProp: t,
      selectedAccountId: s,
      triggerAnalyticsEvent: c,
      authenticationRedirect: u
    }),
    [t, s, c, u]
  );
  return /* @__PURE__ */ C(wr, { i18n: pe, children: /* @__PURE__ */ C(De.Provider, { value: f, children: /* @__PURE__ */ C(hr, { children: /* @__PURE__ */ C(Kr, { value: i, children: /* @__PURE__ */ oe(
    Wr,
    {
      handleModalClose: e,
      isModalOpen: n,
      children: [
        /* @__PURE__ */ C(
          "input",
          {
            id: "Custom_Card_Art_build_version",
            type: "hidden",
            value: zr.BuildVersion
          }
        ),
        /* @__PURE__ */ C(
          qo,
          {
            containerId: r,
            selectedAccountId: s
          }
        )
      ]
    }
  ) }) }) }) });
};
export {
  ma as default
};
//# sourceMappingURL=index.js.map
